import React, { useRef, useState } from "react";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import { viewSelector, closeView } from "~redux/slices/edstSlice";
import { useDragging } from "hooks/useDragging";
import {
  baseBorderColor,
  colorNameMap,
  edstFontDim,
  edstFontName,
  useCenterCursor,
  useFocused,
  usePixiOnClickOutside,
} from "@poscon/shared-frontend";
import type { Container as PixiContainer } from "pixi.js";
import { useZIndex } from "hooks/useZIndex";
import { MenuTitleBar } from "components/utils/MenuTitleBar";
import { TableField } from "components/utils/TableField";
import { openViewThunk } from "~redux/thunks/openViewThunk";
import { InteractiveContainer } from "../utils/InteractiveContainer";
import { EdstButton } from "../utils/EdstButton";

const { width: fontWidth, height: fontHeight } = edstFontDim;

const width = 36 * fontWidth;

export const ToolsMenu = () => {
  const dispatch = useRootDispatch();
  const viewProps = useRootSelector((state) => viewSelector(state, "TOOLS_MENU"));
  const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const ref = useRef<PixiContainer>(null);
  const zIndex = useZIndex("TOOLS_MENU", ref);
  const focused = useFocused(ref);
  useCenterCursor(ref);
  const { startDrag } = useDragging(ref, "TOOLS_MENU", "mouseup");

  usePixiOnClickOutside(ref, () => dispatch(closeView("TOOLS_MENU")));

  return (
    <InteractiveContainer
      ref={ref}
      x={viewProps.position.x}
      y={viewProps.position.y}
      zIndex={zIndex}
      sortableChildren
    >
      <MenuTitleBar
        title="Tools Menu"
        width={width}
        onTitleMouseDown={startDrag}
        view="TOOLS_MENU"
        fontName={edstFontName}
        fill={focused ? colorNameMap.cyan : colorNameMap.mediumGrey}
        tint={colorNameMap.black}
        withX={false}
      />
      <container y={fontHeight + 2} sortableChildren>
        <graphics
          draw={(graphics) => {
            graphics.clear();
            graphics
              .rect(0, 0, width, (fontHeight + 4) * 5 + 8)
              .fill(0)
              .stroke({ width: 1, color: baseBorderColor });
          }}
        />
        <TableField
          textX={2}
          x={4}
          y={4}
          text="Airspace Status..."
          width={width - 8}
          onmousedown={() => {
            dispatch(openViewThunk("AIRSPACE_STATUS"));
            dispatch(closeView("TOOLS_MENU"));
          }}
        />
        <TableField
          textX={2}
          x={4}
          y={4 + fontHeight + 4}
          text="Airport Stream Filter Status..."
          width={width - 8}
          onmousedown={() => {
            dispatch(openViewThunk("AIRPORT_STREAM_FILTER"));
            dispatch(closeView("TOOLS_MENU"));
          }}
        />
        <TableField textX={2} x={4} y={4 + (fontHeight + 4) * 2} text="Options..." width={width - 8} />
        <TableField
          textX={2}
          x={4}
          y={4 + (fontHeight + 4) * 3}
          text="Restrictions..."
          width={width - 8}
          onmousedown={() => {
            dispatch(openViewThunk("RESTRICTIONS"));
            dispatch(closeView("TOOLS_MENU"));
          }}
        />

        <EdstButton
          x={width - edstFontDim.width * 4 - 15}
          y={4 + (fontHeight + 4) * 4}
          text="Exit"
          onmousedown={() => dispatch(closeView("TOOLS_MENU"))}
        />
      </container>
    </InteractiveContainer>
  );
};

const ToolsOptionsMenu = () => {
  // TODO: implement
  return null;
};
